import styled from "@emotion/styled";

export const ButtonWrapper = styled.div`
  margin-bottom: ${p => p.theme.space[7]}px;
`;
